
/**
 * Constants used in the onboarding system
 */

// Master flag that will override everything else
export const GLOBAL_ONBOARDING_FLAG = 'VEGANA-GLOBAL-ONBOARDING-COMPLETED-V2';

// Checklist state key with user-specific suffix
export const getChecklistStateKey = (userId: string) => `vegana-checklist-state-${userId}`;
